import { Switch, Typography, Form } from 'antd';

import { ExtendedMessage } from '@app/components';
import { PREFIX as GLOBAL_PREFIX } from '@app/constants/appPrefix';
import type { NRecordReminders } from '@app/types';

import { LabelWithTime } from '@pages/Notifications/components/LabelWithTime';
import { ReminderFiles } from '@pages/Notifications/components/ReminderFiles';

import type { FormInstance } from 'antd';
import type { RefObject, FC } from 'react';

import '@pages/Notifications/styles/Notification2hReminder.desktop.scss';

const { Title, Text } = Typography;
const { useWatch } = Form;

export const Notification2hReminder: FC<{
  form: FormInstance;
  boxRef: RefObject<HTMLDivElement>;
  reminder: NRecordReminders.ModelRecordReminder | null;
  disabled?: boolean;
}> = ({ form, boxRef, reminder, disabled = false }) => {
  const COMPONENT_CLASS_NAME = `${GLOBAL_PREFIX}notification-2h-reminder`;

  const hoursValue = form.getFieldValue('visitDayIntervalHours') || 0;
  const minutesValue = form.getFieldValue('visitDayIntervalMinutes') || 0;

  const handleHoursChange = (value: number) => {
    form.setFieldsValue({ visitDayIntervalHours: value });
  };
  const handleMinutesChange = (value: number) => {
    form.setFieldsValue({ visitDayIntervalMinutes: value });
  };

  const isVisitDayReminderStatus = useWatch('visitDayReminderStatus', form);

  return (
    <div className={COMPONENT_CLASS_NAME} ref={boxRef}>
      <div className={`${COMPONENT_CLASS_NAME}__header-row`}>
        <Title
          level={4}
          className={`${COMPONENT_CLASS_NAME}__header`}
          data-testid="reminder-on-the-day-of-visit-block-title"
        >
          Напоминание клиенту в день визита
        </Title>
        <div className={`${COMPONENT_CLASS_NAME}__switch-wrap`}>
          <Form.Item
            name="visitDayReminderStatus"
            className={`${COMPONENT_CLASS_NAME}__switch`}
          >
            <Switch
              data-testid={
                form.getFieldValue('createRecordStatus')
                  ? 'active-notification'
                  : 'inactive-notification'
              }
              disabled={disabled}
            />
          </Form.Item>
        </div>
      </div>

      {isVisitDayReminderStatus && (
        <>
          <div
            className={`${COMPONENT_CLASS_NAME}__description`}
            data-testid="reminder-on-the-day-of-visit-description"
          >
            Настройте сообщение, отправляемое клиенту в WhatsApp за несколько
            часов до начала записи (со статусами "Ожидание клиента" и "Клиент
            подтвердил").
          </div>

          <LabelWithTime
            componentClassName={COMPONENT_CLASS_NAME}
            type="before"
            minutesFormItemName="visitDayIntervalMinutes"
            hoursFormItemName="visitDayIntervalHours"
            onHoursChange={handleHoursChange}
            onMinutesChange={handleMinutesChange}
            hoursValue={hoursValue}
            minutesValue={minutesValue}
            disabled={disabled}
          />

          <Text strong data-testid="notification-title">
            Текст уведомления
          </Text>
          <ExtendedMessage
            form={form}
            socialType="whatsapp"
            formItemName="visitDayReminderMessage"
            formItemClassName={`${COMPONENT_CLASS_NAME}__textarea`}
            textAreaDataTestId="notification-template-text"
            disabled={disabled}
          />

          <ReminderFiles
            reminder={reminder}
            componentClassName={COMPONENT_CLASS_NAME}
            disabled={disabled}
          />
        </>
      )}
    </div>
  );
};
